"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerWithBorder = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ContainerWithBorder = styled_components_1.default.div `
  display: inline-block;
  border: 2px solid rgb(128, 128, 128);
  border-radius: 10px;

  text-align: center;

  margin: 10px 0 10px 0;

  padding: 15px;
`;
//# sourceMappingURL=container-with-border.js.map